// a generic controller that triggers a POST request when a select input changes
// html usage: data-controller="select-trigger" data-select-trigger-endpoint-value="/endpoint"
import { Controller } from "@hotwired/stimulus"
import { rrFetch } from "../utils/rr_fetch"

export default class SelectTriggerController extends Controller {
  static targets = ["input"] //html Usage: data-select-trigger-input-target="input"
  static values = {
    endpoint: String,
    payloadKey: String,  // Optional: custom key name for payload (defaults to input's name attribute)
    includeFormFields: Boolean,  // Optional: include all form fields in the request (defaults to false)
    csrfToken: String
  }

  connect() {
    // Listen for change events on the input target
    this.inputTarget.addEventListener("change", this.handleInputChange.bind(this))
  }

  disconnect() {
    this.inputTarget.removeEventListener("change", this.handleInputChange.bind(this))
  }

  handleInputChange(event) {
    const value = event.target.value || ""

    // Submit POST request with the input value
    this.submitRequest(value)
  }

  async submitRequest(value) {
    try {
      if (!this.endpointValue) {
        console.error("selectTriggerController: endpoint value is required")
        return
      }

      // Build FormData for turbo-stream compatible requests
      let formData = new FormData()

      // If includeFormFields is true, gather all form fields
      if (this.includeFormFieldsValue) {
        const form = this.inputTarget.closest('form')
        if (form) {
          const existingFormData = new FormData(form)
          for (const [key, val] of existingFormData.entries()) {
            formData.append(key, val)
          }
        }
      } else {
        // Default behavior: only send the input value
        const payloadKey = this.payloadKeyValue || this.inputTarget.name || "value"
        formData.append(payloadKey, value)

        // Get CSRF token from the main form if available
        const csrfInput = this.csrfTokenValue
        if (csrfInput) {
          formData.append('csrf_token', csrfInput)
        }
      }

      // Send as FormData for compatibility with Go's PostForm
      // Use rrFetch to maintain session handling and embed detection
      const response = await rrFetch(this.endpointValue, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'text/vnd.turbo-stream.html'
        }
      })

      if (!response.ok) {
        console.error(`selectTriggerController: HTTP error! status: ${response.status}`)
      }

      const html = await response.text()

      // Render turbo stream response
      if (html && globalThis.Turbo) {
        await globalThis.Turbo.renderStreamMessage(html)
      }
    } catch (error) {
      console.error("Error in selectTriggerController:", error)
    }
  }
}

